<template>

 
<!-- 
 <div class="d-flex align-items-center justify-content-center">
 <div style="max-width: 200px; text-align: left; ">
    <strong>This is a preview.</strong>
    <div class="border-warning bg-warning"> 
        Thanks for taking a look at our video lesson preview. We'll be updating video lessons based on your feedback.
        If you run into an issue or have a suggestion please <a href="/contact">contact us</a> or reach out on Discord.
        <br><br>
        Cheers,<br>
        <br>
        Brian 
    </div>
 </div>
 </div> -->

 <div class="d-flex align-items-center justify-content-center">

    <div class="d-flex flex-wrap lesson-horizontal pt-4"> 
        <div class="btn btn-secondary btn-responsive mr-2" @click="replay">
            <icon :name="'arrow-counterclockwise'" />
            <span class="ml-1">Replay</span>
        </div>
    </div>

 <div   class="p-4" v-if="completeLessonResponse?.nextLesson && lessonController?.lessonOptions?.courseUid" >
        <div>Advance to <strong>{{completeLessonResponse?.nextLesson?.title}}</strong></div>
        <div><i>start the next lesson</i></div>

        <lesson-item class="icon-only  mt-3" :showTitle="false" 
        :lesson="completeLessonResponse.nextLesson" :course="{uid: lessonController?.lessonOptions?.courseUid}"  >
            <template  v-slot:badge-right >
                <span class="badge badge-primary badge-round" >     
                    <span class="go">Go</span>
                    <icon :name="'chevron-right'" />
                </span>
            </template>
        </lesson-item>
        </div>

<div class="d-flex flex-wrap lesson-horizontal pt-4"> 
    <a v-if="!lessonController?.lessonOptions?.courseUid" class="btn btn-secondary btn-responsive mr-2"
    @click="shellController?.splash('course',true,'Loading Dashboard')"
    href="/dashboard" > Back to Dashboard</a>
    <a 
    @click="shellController?.splash('course',true,'Loading Course')"
            v-if="lessonController?.lessonOptions?.courseUid" class="btn btn-secondary  btn-responsive mr-2" :href="`/course/${lessonController?.lessonOptions?.courseUid}`" >Back to Course</a>  


        <a v-if="!completeLessonResponse.nextLesson" class="btn btn-primary  btn-responsive"
        @click="shellController?.splash('course',true,'Loading...')"
        :href="getContinueUrl()" >Continue</a>
    </div>
 </div>  

</template> 

<script lang="ts" setup>
import { LessonController } from '@/controllers/LessonController';
import { inject } from 'vue';
import { ShellController } from '../shell/Shell';
import { CompleteLessonResponse, LessonInfo } from '@/data/repository/CourseRepository';
import LessonItem from '../course/LessonItem.vue';
import Icon from '../core/Icon.vue';

const lessonController = inject<LessonController>("lessonController")!;
const shellController = inject<ShellController>("shellController")!;

const props  = defineProps<{
  completeLessonResponse: CompleteLessonResponse,
  loggedIn: boolean
}>()

const emit = defineEmits(['replay']);

const replay=()=>{
    emit('replay')
}
 
const  getContinueUrl=() =>
    {
        if (lessonController?.options?.courseUid=='demo')
        {
            return '/dashboard'
        }
        // else if (!isLoggedIn)
        // {
        //     const returnUrl=this.getCourseEnrollmentUrl().split('/').join('%2f');
        //     return '/Identity/Account/Register?returnUrl=' + returnUrl;
        // }
        // else { 
        //     return this.getCourseEnrollmentUrl();
 
        // }
    }
</script>

<style lang="scss" scoped>

.btn-video-lesson-replay {
    font-size:16rem;
}

</style>